import { useEffect } from "react";
import Helpers from "@/Helpers";
import { renderFormattedContent } from "@/utils/renderFormattedContent";

// Live FormId is 2200 (1900 is already Behaviors2). Prefer name so editor/runtime
// still render if FormId was remapped after a collision.
const USER_PROMPT_FORM_ID = 2200;

export default function UserPrompt(props) {
   const { sectionData, values } = props;
   const currentSection = sectionData?.currentSection;
   const languageContent = Helpers.getSectionContent(currentSection, sectionData?.lang);
   const elements = Helpers.getSectionElements(languageContent);
   const instructionsHtml = String(Helpers.getSectionHtmlValue(languageContent, "instructions") || "");

   const checkbox = elements?.checkbox || {};
   const checkboxVisible = checkbox?.visible === true;
   const checkboxRequired = checkboxVisible && checkbox?.required === true;
   const checkboxLabel = String(checkbox?.label ?? "");
   const checkboxKey = String(Number(currentSection?.formId || 0) + 1);
   const checked = String(values?.[checkboxKey] ?? "0") === "1";

   function isOnTab() {
      return currentSection?.name === "UserPrompt"
         || Number(currentSection?.formId) === USER_PROMPT_FORM_ID;
   }

   function getIssueCount(validationValues) {
      if (!checkboxRequired) return 0;
      return String(validationValues?.[checkboxKey] ?? "0") === "1" ? 0 : 1;
   }

   useEffect(() => {
      if (!isOnTab()) return;
      sectionData.registerSection(null, checkboxVisible ? 1 : 0);
   }, [sectionData?.currentSection?.name]);

   useEffect(() => {
      if (!isOnTab()) return;
      const nextCount = Number(sectionData?.nextCount || 0);
      const issueCount = nextCount > 0 ? getIssueCount(values || {}) : 0;
      sectionData?.updateIssueCount?.(issueCount);
   }, [checkboxRequired, sectionData?.nextCount, sectionData?.updateIssueCount, values]);

   if (!isOnTab()) return;

   async function onToggle() {
      await sectionData.onAnswer(1, checked ? "0" : "1");
   }

   const showCheckboxIssue = !!sectionData?.showValidations && getIssueCount(values || {}) > 0;

   return (
      <div className="userPrompt">
         {instructionsHtml && (
            <div className="instructions left">{renderFormattedContent(instructionsHtml)}</div>
         )}
         {checkboxVisible && (
            <div className={showCheckboxIssue ? "userPromptCheckbox pending" : "userPromptCheckbox"}>
               <label>
                  <input
                     type="checkbox"
                     className={showCheckboxIssue ? "oops" : ""}
                     checked={checked}
                     onChange={onToggle}
                  />
                  <span className="userPromptCheckboxLabel">{renderFormattedContent(checkboxLabel)}</span>
               </label>
            </div>
         )}
      </div>
   );
}
